import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadTags, showNewTagsModal } from '../../redux/modules/tags';
import { TagsPanel } from '../../components/panels/TagsPanel/TagsPanel';
import { MovieDetailsPanel } from './MovieDetailsPanel';
import MoviePurchasePanel from './MoviePurchasePanel';
import { useSelector, useSettingsSelector } from 'src/client/redux';
import { Movie } from 'src/@types/Movie';
import { PanelsGrid } from './PanelsGrid';

type Props = {
  gallery: Movie;
  hasAccess: boolean;
};

export const MoviePanels = ({ gallery, hasAccess }: Props) => {
  const dispatch = useDispatch();

  const tags = useSelector((state) => state.tags.tags);
  const showTags = useSettingsSelector('tags');
  const user = useSelector((state) => state.auth.user);

  const userTags = tags[gallery.UUID] ? tags[gallery.UUID].tags : [];
  const combinedTags = [...userTags, ...gallery.uniqueTagsWithUrl];

  useEffect(() => {
    if (!user) return;

    dispatch(loadTags({ objectUUID: gallery.UUID, type: 'MOVIE' }));
  }, [user, gallery.UUID, dispatch]);

  const addNewTag = useCallback(() => {
    if (!user) return;

    dispatch(showNewTagsModal({ name: gallery.name, objectUUID: gallery.UUID, objectType: 'movie' }));
  }, [dispatch, gallery.name, gallery.UUID, user]);

  return (
    <PanelsGrid>
      <MovieDetailsPanel movie={gallery} isTrailer={!hasAccess} className="movie-details" />
      {!hasAccess && <MoviePurchasePanel gallery={gallery} className="movie-purchase" />}
      {!!showTags && <TagsPanel tags={combinedTags} userTags={userTags} onAddNewTag={addNewTag} />}
    </PanelsGrid>
  );
};
